var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LOGO_HORZ_ENDOSO } from "../../../../assets/images";
import Footer from "../../../common/Footer/Footer";
import Loader from "../../../common/Loaders/Loader";
import ErrorComponent from "../../Error/ErrorComponent";
import { ErrorEnum } from "../../Error/ErrorEnum";
import { submitPaymentResponse } from "../../../../api/Payments/paymentService";
const PaymentsFeedbackKo = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(true);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [responseContent, setResponseContent] = useState(null);
    useEffect(() => {
        setIsLoading(true);
        const fetchPaymentResponse = () => __awaiter(void 0, void 0, void 0, function* () {
            const queryParams = new URLSearchParams(location.search);
            const ds_SignatureVersion = queryParams.get('Ds_SignatureVersion');
            const ds_MerchantParameters = queryParams.get('Ds_MerchantParameters');
            const ds_Signature = queryParams.get('Ds_Signature');
            try {
                const response = yield submitPaymentResponse({
                    ds_MerchantParameters,
                    ds_Signature,
                    ds_SignatureVersion
                });
                if (response !== null) {
                    setResponseContent(response);
                }
            }
            catch (error) {
                console.error('Error al procesar respuesta del pago:', error);
                setIsError(true);
            }
            finally {
                setIsLoading(false);
            }
        });
        fetchPaymentResponse();
    }, []);
    const printBill = () => {
        window.print();
    };
    const downloadBill = () => {
    };
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsxs("title", { children: ["SIGNO | ", t('payments.title')] }) }), isLoading ? (_jsx(Loader, { cssClass: 'grid-mt-8' })) :
                _jsxs("div", Object.assign({ className: "payments-feedback" }, { children: [_jsx("div", Object.assign({ className: "container-xl payments-feedback-header" }, { children: _jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-12 col-md-11 header-content mx-auto" }, { children: _jsx("img", { alt: "SIGNO", onClick: () => navigate('/'), className: "header-logo", src: LOGO_HORZ_ENDOSO }) })) })) })), _jsx("div", Object.assign({ className: "container-xl" }, { children: _jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-12 col-md-11 payments-feedback-body mx-auto" }, { children: _jsx(ErrorComponent, { error: ErrorEnum.PAYMENTS_KO, url: `/payments/${responseContent === null || responseContent === void 0 ? void 0 : responseContent.companyId}`, btnText: 'common.btn.tryAgain', goToInitBtnSecondAction: true }) })) })) })), _jsx("div", Object.assign({ className: "container-xl" }, { children: _jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-12 col-md-11 mx-auto" }, { children: _jsx(Footer, {}) })) })) }))] }))] }));
};
export default PaymentsFeedbackKo;
